import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useConsent } from "./ConsentContext";
import { useLang } from "../i18n";

export function CookieBanner() {
  const { decided, acceptAll, rejectAll, openPreferences, prefOpen } = useConsent();
  const { t } = useLang();
  const show = decided === false && !prefOpen;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          role="dialog" aria-modal="false" aria-label={t.cookies.title}
          data-testid="cookie-banner"
          initial={{ y: 120, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 z-[60] md:max-w-md"
        >
          <div className="relative bg-white rounded-2xl border border-wanm-offwhite shadow-[0_20px_60px_rgba(53,53,53,0.18)] p-6 md:p-7">
            <div className="h-1 w-full wanm-gradient-bg rounded-full absolute top-0 left-0 right-0" />
            <div className="flex items-center gap-2 mb-3 mt-1">
              <div className="w-9 h-9 rounded-full wanm-gradient-bg flex items-center justify-center">
                <Cookie size={18} className="text-white" />
              </div>
              <h2 className="text-lg font-black text-wanm-dark">{t.cookies.title}</h2>
            </div>
            <p className="text-sm text-wanm-dark/70 leading-relaxed">
              {t.cookies.body}{" "}
              <Link to="/cookie-policy" className="font-bold text-wanm-red underline underline-offset-2">
                {t.cookies.policyLink}
              </Link>
            </p>
            <div className="mt-5 flex flex-col gap-2.5">
              <button onClick={acceptAll} data-testid="cookie-accept-all"
                className="wanm-gradient-bg text-white font-bold rounded-full py-2.5 hover:scale-[1.02] transition-transform">
                {t.cookies.acceptAll}
              </button>
              <div className="flex gap-2.5">
                <button onClick={rejectAll} data-testid="cookie-reject-all"
                  className="flex-1 border-2 border-wanm-dark/20 text-wanm-dark font-bold rounded-full py-2.5 hover:border-wanm-dark transition-colors">
                  {t.cookies.rejectAll}
                </button>
                <button onClick={openPreferences} data-testid="cookie-manage"
                  className="flex-1 border-2 border-wanm-dark/20 text-wanm-dark font-bold rounded-full py-2.5 hover:border-wanm-dark transition-colors">
                  {t.cookies.manage}
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default CookieBanner;
